import React, { useState } from 'react'

import HeroSectionMedilearn from '../../molecules/HeroSectionMedilearn/HeroSectionMedilearn'
import OverviewMedilearn from '../../molecules/OverviewMedilearn/OverviewMedilearn'
import ProblemMedilearn from '../../molecules/ProblemMedilearn/ProblemMedilearn'
import MedilearnImpact from '../../atoms/MedilearnImpact/MedilearnImpact'
import OutcomeMedilearn from '../../molecules/OutcomeMedilearn/OutcomeMedilearn'
import KeyFeatureSection from '../../molecules/KeyFeatureSection/KeyFeatureSection'
import IntroAnimation from '../../organisms/IntroAnimation/IntroAnimation'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import colors from '../../theme/color'

import star from '../../../assets/images/medilearn/star.svg'

const Medilearn = () => {
      const [startAnimation, setStartAnimation] = useState(false)
    
      // 🔥 FORCE RE-MOUNT INTRO EVERY VISIT
      const [introKey] = useState(() => Date.now())
  return (
    <main className="relative overflow-hidden bg-[#9BB069]">

     {/* STAR 1 — LEFT */}
<img
  src={star}
  alt=""
  className="
    pointer-events-none
    absolute
    z-0

    left-[-1%]
    top-[29%]

    md:left-[1%]
    md:top-[31%]

    lg:left-[4%]
    lg:top-[34%]

    xl:left-[5%]
    xl:top-[34%]

    2xl:left-[7%]
    2xl:top-[40%]

    w-[40px]
    md:w-[70px]
    lg:w-[90px]
    xl:w-[120px]
    2xl:w-[160px]

    opacity-70
  "
/>

{/* STAR 2 — RIGHT */}
<img
  src={star}
  alt=""
  className="
    pointer-events-none
    absolute
    z-0

    right-[2%]
    top-[50%]

    md:right-[4%]
    md:top-[44%]

    lg:right-[5%]
    lg:top-[48%]

    xl:right-[5%]
    xl:top-[49%]

    2xl:right-[6%]
    2xl:top-[53%]

    w-[50px]
    md:w-[80px]
    lg:w-[100px]
    xl:w-[140px]
    2xl:w-[180px]

    rotate-[18deg]
    opacity-70
  "
/>

{/* STAR 3 — LEFT */}
<img
  src={star}
  alt=""
  className="
    pointer-events-none
    absolute
    z-20

    left-[-2%]
    top-[72%]

    md:left-[-1%]
    md:top-[59%]

    lg:left-[1%]
    lg:top-[64%]

    xl:left-[1%]
    xl:top-[66%]

    2xl:left-[4%]
    2xl:top-[68%]

    w-[45px]
    md:w-[75px]
    lg:w-[95px]
    xl:w-[130px]
    2xl:w-[170px]

    -rotate-[15deg]
    opacity-70
  "
/>

      {/* Content */}
      <div className="relative z-10">
               <IntroAnimation
              key={introKey}
              words={['MEDILEARN']}
              wordColors={['#f8f8f8', '#ffffff']}
              backgroundGradient={{
                top: '#9BB069',
                bottom: '#a4af8bff',
              }}
              onHeroStart={() => setStartAnimation(true)}
            />
        <HeroSectionMedilearn />
        <OverviewMedilearn />
        <ProblemMedilearn />
        <KeyFeatureSection />
        <OutcomeMedilearn />
        <MedilearnImpact />
        <div
          className="w-full py-10 md:py-14"
          style={{ background: colors.medilearnSectionGradient }}
        >
          <Testimonial className="mx-auto mb-20 max-w-[90%]" showHeader themeColor="medilearntheme" />
          <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
            <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
              <Message themeColor="medilearntheme" />
              <Questions themeColor="medilearntheme" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </main>
  )
}

export default Medilearn